import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import AnonymousBlankSlate from 'modules/surveys/components/Analytics/AnonymousBlankSlate'
import AnswersModal from 'modules/surveys/components/Analytics/ScoreResults/_AnswersModal'
import Head from 'modules/surveys/components/Analytics/ScoreResults/_Head'
import Bars from 'modules/surveys/components/Analytics/ScoreResults/charts/Bars'
import { useAnswers, useRatingData } from 'modules/surveys/components/Analytics/ScoreResults/hooks'
import type { Answer } from 'modules/surveys/components/Analytics/ScoreResults/hooks'
import { useAnalytics } from 'modules/surveys/pages/Show/hooks'
import type { Question } from 'modules/surveys/store/models/AnalyticResult'

interface Props {
  question: Question
}

const Rating = ({ question }: Props) => {
  const { analyticResult, form, cycle } = useAnalytics()
  const questionGroups = analyticResult?.questionGroupsInCycle(cycle) ?? []
  const answers: Answer[] = useAnswers(question, questionGroups).get()
  const { data, minValue, maxValue } = useRatingData(question, answers).get()
  const [modalOpen, setModalOpen] = useState(false)
  const [modalAnswers, setModalAnswers] = useState<Answer[]>([])
  const isAnonymous = form.isAnonymous

  const onClick = (answer_label: number | string) => {
    setModalAnswers(answers.filter((answer) => answer?.value?.toString() === answer_label))
    setModalOpen(true)
  }

  const filtered = answers.filter((val) => {
    return val.value
  })

  return (
    <Box
      background="grey200"
      borderRadius={{
        all: 'abs008',
      }}
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
    >
      <Head answers={answers} question={question} />
      <Box
        border={{
          top: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
      >
        {isAnonymous && !filtered.length ? (
          <AnonymousBlankSlate />
        ) : (
          <Bars
            data={data}
            direction="vertical"
            minValue={minValue}
            maxValue={maxValue}
            onClick={!isAnonymous ? onClick : undefined}
          />
        )}
        {modalOpen && (
          <AnswersModal
            question={question}
            answers={modalAnswers}
            onClose={() => setModalOpen(false)}
          />
        )}
      </Box>
    </Box>
  )
}

export default observer(Rating)
